import React, { Component } from "react";
import { Link } from "react-router";
import { imageUrl } from "helpers/ApplicationHelper";
import I18n from "lib/i18n/i18n";
import Properties from "components/item/properties";
import BannersBox from "components/banners/auctionBanner";
import BidsSection from "./bidsSection";
import ImageGallery from "../imageGallery";

class SupportNegotiation extends Component {
  constructor(props) {
    super(props);
    this.changeState = this.changeState.bind(this);

    this.state = {
      banner: props.item.banner_status,
      enableSuppport: props.item.enable_support_negotiation,
    };
  }

  changeState(opt) {
    this.setState({ banner: opt });
  }

  render() {
    return (
      <div
        id="item-evaluation-ready"
        className={this.state.enableSuppport ? "" : "hidden"}
      >
        <Link to="/items" target="_self" className="back-history">
          <img src={imageUrl("item/little_arrow.svg")} />{" "}
          {I18n.getString("itemPage::supportNegotiation::my_items")}
        </Link>
        <BannersBox
          item={this.props.item}
          banner={this.state.banner}
          changeStateTo={this.changeState}
        />
        <div id="item-properties">
          <div className="tag">
            {I18n.getString(
              `itemPage::supportNegotiation::${this.state.banner}::tag`
            )}
          </div>
          <h2 className="item-desc">{this.props.item.desc}</h2>
          <BidsSection
            item={this.props.item}
            banner={this.state.banner}
            className="mobile"
          />
          <ImageGallery images={this.props.item.images.slice(0, 4)} />
          <Properties item={this.props.item} showSellerNotes={true} />
        </div>
      </div>
    );
  }
}

export default SupportNegotiation;
